import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { ClassValue } from "clsx";

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};

export type Split<
  TString extends string,
  TPivot extends string,
> = string extends TString
  ? Array<string>
  : TString extends ""
    ? []
    : TString extends `${infer T}${TPivot}${infer U}`
      ? [T, ...Split<U, TPivot>]
      : [TString];

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}

const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  compactDisplay: "short",
  maximumFractionDigits: 1,
});

export function formatCompactNumber(value: number) {
  return compactNumberFormatter.format(value);
}

export function formatCompactMinutes(value: number) {
  const unit = value === 1 ? "minute" : "minutes";
  return `${formatCompactNumber(value)} ${unit}`;
}
